import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

// API slice para las operaciones del programa designer que usan RPCs de Supabase.
// Las llamadas van a través del proxy autenticado (/api/supabase-proxy?resource=rpc/<fnName>)
// en lugar de llamar directamente al cliente de Supabase con la clave anon.
// Las RPCs de PostgREST siempre usan POST, incluso las de solo lectura.
// La respuesta del proxy devuelve el jsonb del RPC directamente:
//   { success: boolean, program_id?: number, data?: any, error?: string }
//
// Nota sobre invalidación de caché: create y update invalidan el tag 'ProgramDesigner'
// para esta slice. Para invalidar también la lista de programas de programApi (que usa
// el tag 'Program'), los componentes deben llamar dispatch(programApi.util.invalidateTags(...))
// después del .unwrap() — la invalidación cross-slice no funciona via tagTypes compartidos
// entre instancias separadas de createApi.

const programDesignerApi = createApi({
  reducerPath: 'programDesigner',
  tagTypes: ['ProgramDesigner'],
  baseQuery,
  endpoints(builder) {
    return {
      // Crea un nuevo programa usando el designer. Devuelve { success, program_id, error? }
      createProgramDesigner: builder.mutation({
        invalidatesTags: ['ProgramDesigner'],
        query: (program_data) => ({
          url: '?resource=rpc/create_program_new_designer',
          method: 'POST',
          body: { program_data },
        }),
      }),

      // Carga un programa para editar en el designer. Se implementa como mutation
      // para poder llamarse imperativamente desde loadProgram (no como query declarativa).
      // Devuelve { success, data, error? }
      getProgramDesigner: builder.mutation({
        query: (p_program_id) => ({
          url: '?resource=rpc/get_program_for_newdesigner',
          method: 'POST',
          body: { p_program_id },
        }),
      }),

      // Actualiza un programa existente desde el designer. Devuelve { success, error? }
      updateProgramDesigner: builder.mutation({
        invalidatesTags: ['ProgramDesigner'],
        query: ({ p_program_id, program_data }) => ({
          url: '?resource=rpc/update_program_new_designer',
          method: 'POST',
          body: { p_program_id, program_data },
        }),
      }),
    };
  },
});

export const {
  useCreateProgramDesignerMutation,
  useGetProgramDesignerMutation,
  useUpdateProgramDesignerMutation,
} = programDesignerApi;

export { programDesignerApi };
